import React from 'react';
import Lottie from 'lottie-react';
import animationData from './../../assets/bot/littlegirl.json';
import './AnimatedAvatar.css';
const AnimatedAvatar = () => {
    return (
        <div className="animation-container">
            <Lottie animationData={animationData} style={{ width: '500px', height: '500px' }}
            />
        </div>
    );
}

export default AnimatedAvatar;
